import { render, staticRenderFns } from "./editswitch.vue?vue&type=template&id=5fe7c670&"
import script from "./editswitch.vue?vue&type=script&lang=ts&"
export * from "./editswitch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "editswitch.vue"
export default component.exports